define('modules/form_editor/models/custom_privacy',['require','exports','module','./check_group'],function(require,exports,module){
  "use strict";

  var CheckboxGroup = require("./check_group");

  var CustomPrivacyModel = CheckboxGroup.extend({
    name: "custom:privacy",
    defaults: {
      labelVisible: true,
      isRequired: false,
      isRequiredReadOnly: true,
      widthClass: "one-whole",
      elementId: "legal-priv"
    }
  });
  module.exports = CustomPrivacyModel;
});

